export default function getPostLink (item, full = false) {
  return item?.link || `${full ? '/help' : ''}/post/${item.value}`
}
